/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClassificationSettingRequest = {
  label?: string | null
  /**
   * * `label` - Label
   * * `boundary` - Boundary
   */
  type: ClassificationSettingRequest.type
  lower_bound: number
  upper_bound: number
}
export namespace ClassificationSettingRequest {
  /**
   * * `label` - Label
   * * `boundary` - Boundary
   */
  export enum type {
    LABEL = "label",
    BOUNDARY = "boundary",
  }
}
